import styled, { css } from "styled-components";
import { Row, Columns } from "./commonStyles";
// eslint-disable-next-line import/named
import { mediaMaxWidth } from "../utils/mediaQuery";

const RowContainer = styled(Row)`
	align-items: flex-start;
`;

const MainContentColumns = styled(Columns)`
	background-color: ${(props) => props.bgColor || "#f5f5f5"};
	position: relative;
	z-index: 2;
	overflow: hidden;
	${(props) =>
		props.postPage &&
		css`
			${mediaMaxWidth.small`
				&::after {
					content: "";
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 170px;
					background-color: ${props.bgColor || "#f5f5f5"};
					z-index: -1;
				}
			`}
		`};

	${(props) =>
		props.clean &&
		css`
			background-color: #fff;
			border-radius: 0;

			&::after {
				content: none;
			}
		`};

	${(props) =>
		props.jobsPage &&
		css`
			box-shadow: 0 8px 8px 5px rgba(33, 33, 33, 0.02);
			border: solid 1px #eaeaea;
			background-color: #ffffff;
			${mediaMaxWidth.medium`
				box-shadow: none;
				border: none;
				border-bottom: 1px solid #eaeaea;
			`}
		`}
`;
const CTAColumns = styled(Columns)`
	max-width: 400px;
	padding-left: 20px;
`;

const CardContainer = styled.div``;
const CardWrapper = styled.div`
	width: 100%;
	max-width: 470px;
	margin: 0 auto 25px;
	padding: 0 15px;
`;

const SectionSmallHeading = styled.h4`
	font-size: 18px;
	font-weight: 900;
	color: #373737;
`;
const CardCarouselContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 100%;

	& > div:not(:last-child) {
		margin-right: 15px;
	}

	${mediaMaxWidth.medium`
		flex-wrap: wrap;
		justify-content: center;
		&&& > div {
			margin-right: 0;
			width: 100%;
		}
	`};
`;
const MobileContainer = styled.div`
	${mediaMaxWidth.small`
		display: block;
		padding: 0 15px;
    `}
`;

module.exports = {
	RowContainer,
	MainContentColumns,
	CTAColumns,
	CardContainer,
	CardWrapper,
	SectionSmallHeading,
	CardCarouselContainer,
	MobileContainer,
};
